/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : common.ts
*******************************************/

import { PropertyConfig } from "@api-commons/config/PropertyConfig.js";
import { BarrierDisplayMode } from "@api-commons/sdk/aaa/AAABarrierWithSource.js";

const domain = "cookist.run";
const host = "api." + domain;
const secure = true;

export const commonConfig: PropertyConfig = {
    version: "8.0.0",
    debug: true,
    host: host,
    domain: domain,
    site: "cookist",
    siteName: "Cookist.it",
    mainUrl: "https://www.cookist.run",
    assetsDistro: "https://api.cookist.run",
    assetsCacheBuster: "1671031069",
    serverSdkEndpoint: "/embed/channel70",
    sdkJsServer: {
        domain: domain,
        host: domain,
        path: "/local/cookist/it/sdk/cookist/it-server-sdk-dev.js",
        secure: true
    },
    secure: secure,
    applicationToken: {

        web: "643727469323|T74jge6Hexy01IHAdtiGjDpPbvCtNP0Lq1Bi2GuHUvICtpc9Q4PvMPn6uq3IvAOa",
        ios: "149779102342|Eooe9SWPpcGuOnBb9NEVfwHKrbtF9g0Fi6xS4vldAxpk9Aii8KxeiP4MVHQr923a",
        android: "123716563012|8QevQ03nk1rACRu8WsOpYu4sSUbb7OCOCBcQbdWxzxdwLtcXMjJ4QueiOxBzLYuI"
    },
    cookies: {
        names: {
            session: "ckit_ut",
            logout: "ckit_lo",
            fbToken: "ckit_fbtk",
            aes: "fp_ad",
            loginPreviousState: "ckit_lpsnu",
            lastLoginProvider: "ckit_lprov",
            audienceToken: "apat"
        },
        cookieDomain: ".cookist.run",
        cookieversion: 8,
    },
    loginManager: {
        barrierDisplayMode: BarrierDisplayMode.SHOW_DIALOG,
        actual_providers: {
            facebook: {
                enabled: true,
                applicationIdentifier: "1929187740633762",
                scopes: ["public_profile", "email", "user_birthday", "user_gender"]
            },
            google: {
                enabled: true,
                applicationIdentifier: "639148111984-sb5ghhf1q0j7pdoh2c6ub7jpvfbvmv1i.apps.googleusercontent.com",
                scopes: ["https://www.googleapis.com/auth/user.gender.read", "https://www.googleapis.com/auth/user.birthday.read"]
            },
            apple: {
                enabled: true,
                scopes: ['email', 'name'],
                // @note workaround perchè non utilizzato direttamente
                applicationIdentifier: ""
            },
            email: {
                enabled: true,
                scopes: [],
                applicationIdentifier: ""
            }
        },
        /**
         * firebase app configuration goes here
         */
        firebase: {
            apiKey: "AIzaSyCWssFYRf-lzUmWAdcrQVESTKq6t7Nde3k",
            authDomain: "cookistit-users-staging.firebaseapp.com",
            projectId: "cookistit-users-staging",
            messagingSenderId: "639148111984",
            appId: "1:639148111984:web:ae9ff47e28647719005cb5",
            measurementId: "G-K98X84J7KB"
        },
        autologin: {
            enabled: true,
            retrieveActualDataAlways: false,
        },
        firebaseAccountMergeEnable: true,
        revokeOnClientSideOnDeletion: true
    },
    // parse: {
    //     login: false,
    //     follows: true,
    //     bookmarks: true
    // },
    support: {
        native_apps: true,
        bookmarks: true,
        newsletters: false
    },
    nativeApp: {
        product: "cookist_it",
        schema_intent: "cookistit",
        ios_alternative_url: "https://cooki.st/cookist_ios",
        android_alternative_url: "https://cooki.st/cookist_android",
        dynamicLink: {
            baseUrl: "https://cookistitst.page.link/app",
            apn: "com.ciaopeople.fanpage.cucina",
            amv: "3",
            ibi: "com.ciaopeople.fanpage.cucina",
            isi: "1221389274",
            ius: "cookistit"
        }
    },
    webPush: {
        publicKey: "BNhQfsDbIbj/1jSwoyZ9saq/6EPEFSCYPeWOiXN7NRcs3qPV2Sf1sfN+xgxF+ExQNZMEb4qp7VFa72Z4yDLIBSI=",
        vapiKey: "BNhQfsDbIbj_1jSwoyZ9saq_6EPEFSCYPeWOiXN7NRcs3qPV2Sf1sfN-xgxF-ExQNZMEb4qp7VFa72Z4yDLIBSI",
        serviceWorkerPath: "/serviceworker/v7/sw.js",
        serviceWorkerHost: "cookist.run"
    },
    snhubConfig: {
        host: host,
        domain: domain,
        secure: secure,
        enabled: true,
        cookies: {
            userdata: "fp_snu_ud",
            token: "fp_snu_tk",
            oldToken: "fp_snu_oldtk",
            next_check: "fp_snu_nc",
            role: "fp_snu_role" 
        }
    },
    ga4: {
        accountId: "G-WE9QZ4Q5TB",
        cookieDomain: ".cookist.run"
    },
    contacts: {
        dataDeletionEmail: "richieste-cancellazione@cookist.it" 
    },
    appDownloadLink: {
        "app-store": "https://apps.apple.com/it/app/cookist/id1221389274",
        "google-play": "https://play.google.com/store/apps/details?id=com.ciaopeople.fanpage.cucina"
    },
    links: {
        privacyPolicy: 'https://www.cookist.it/privacy-policy/'
    }
};
